import { render, staticRenderFns } from "./TaskRequestList.vue?vue&type=template&id=1824e3b7&scoped=true"
import script from "./TaskRequestList.vue?vue&type=script&lang=js"
export * from "./TaskRequestList.vue?vue&type=script&lang=js"
import style0 from "./TaskRequestList.vue?vue&type=style&index=0&id=1824e3b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824e3b7",
  null
  
)

export default component.exports